import {
  Button,
  Chip,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Input,
  Select,
  SelectItem,
  Textarea,
  useDisclosure,
} from "@nextui-org/react";

import React, { useEffect, useMemo, useState } from "react";

import {
  ApprovalWorkFlowDataSchemaObj,
  CategoryList,
  FieldList,
  FrequecyCountMap,
  FrequencyDataObj,
} from "../../utils/constant";
import { getFieldInfoListFromGetJSonSchema } from "../../utils/helper";
import PreviewForm from "./PreviewForm";
import EnhancedPreviewForm from "./EnhancedPreviewForm";
import { FaChevronDown } from "react-icons/fa";
import {
  UpdateOneData,
  UpdateSingleCollectionData,
  getDataWithFilterUrl,
  getSingleCollectionData,
} from "../../controllers/APIController";
import AddModal from "./AddModal";
import FieldInfoTable from "./FieldInfoTable";
import { useNavigate, useParams } from "react-router-dom";
import AddFormulaModal from "./AddFormulaModal";
import FormulaInfoTable from "./FormulaInfoTable";
import {
  CustomFrequencyInput,
  DropDownInput,
  MultiSelectInput,
} from "./InputField/InputField";
import MetricTagInput from "./InputField/MetricTagInput";
import useGetAllModels from "../../hooks/useGetAllModels";
import {
  getAllApproverOfOrgnization,
  getAllReviewerOfOrgnization,
  getAllUserOfOrgnization,
} from "../../utils/helper";
import {
  ApproverUserSchemaObj,
  AssignedToUserSchemaObj,
  ReviewerUserSchemaObj,
  sectorSchema,
} from "../../constant/FormBuilder/FormBuilderConstant";
import useGetSectorName from "../../hooks/useGetSectorName";
import useGetDefaultOrg from "../../hooks/useGetDefaultOrg";
import FrameworFieldAccodian from "./FrameworFieldAccodian";
import {
  getJSonSchemaFromFieldInfoList,
  getLinkJsonReponse,
  generateUniqueId,
} from "../../utils/frombuilder.utils";
import GroupedDataPreview from "./GroupedDataPreview";
import QuickPreviewModal from "./QuickPreviewModal";
import FormFieldArranger from "./FormFieldArranger";
import { faArrowsAltH } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StandardAddButton, StandardSubmitButton } from "../../components/StandardButtons";
import { useQueries, useQuery, useQueryClient } from "@tanstack/react-query";

const initialFormData = {
  metricName: "",
  categoryName: "",
  className: "",
  description: "",
  frameWork: [],
  SectorText: "",
  preferredLayout: "2-column", // Default to 2-column layout
};



const getLinkInfoListFromJson = (list) => {
  const response = [];

  list?.forEach((item) => {
    response?.push({
      id: item?.id,
      Title: item?.name,
      link: item?.link,
      Type: "link",
      name: "link",
    });
  });
  return response;
};

const UIMetricBuilderValidation = (formData, fieldInfoList, requiredArr) => {
  const err = {};
  let isValid = true;

  if (fieldInfoList?.length === 0) {
    err["BuildData"] = "Build Data should have atleast one field";
    isValid = false;
  }

  Object?.keys(formData)?.map((key) => {
    if (requiredArr?.includes(key) && formData?.key === "") {
      err[key] = `${key} is required`;
      isValid = false;
    }
  });
  return { isValid: isValid, error: err };
};

const EditUIFormBuilder = () => {
  const { allModels, setAllModels } = useGetAllModels();

  const [formData, setFormData] = useState(initialFormData);
  const [jsonData, setJsonData] = useState("");
  const clientQuery = useQueryClient();
  const { allSectorName } = useGetSectorName();
  
  // Set default sector when sectors are loaded (only if not already set from API)
  useEffect(() => {
    if (allSectorName?.length && !formData?.SectorText) {
      const generalSector = allSectorName?.find(sector => 
        sector?.name?.toLowerCase() === "general"
      );
      const defaultSector = generalSector || allSectorName[0];
      if (defaultSector) {
        setFormData(prev => ({
          ...prev,
          SectorText: defaultSector.name
        }));
      }
    }
  }, [allSectorName, formData?.SectorText]);
  const { OrgDetail: DefaultOrgDetail } = useGetDefaultOrg();

  const [sectionText, setSectorText] = useState("");
  const [frameWorkList, setFrameWorkList] = useState([]);
  const [frameWorkDetails, setFrameWorkDetails] = useState({});
  const [MetricNameList, setMetricNameList] = useState({});
  const [overviewList, setOverviewList] = useState({});
  const [guidanceList, setGuidanceList] = useState({});

  const requiredArr = ["metricName", "categoryName", "jsonSchema"];
  const [validationErrors, setValidationErrors] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState({});

  const [fieldType, setFieldType] = useState("");
  const [fieldInfoList, setFieldInfoList] = useState([]); // JsonSchema Input field info
  const [LinkInfoList, setLinkInfoList] = useState([]); // Link field info in Metric
  const [selectedFormulaList, setSelectedFormulaList] = useState([]);

  const [FormulaInfoList, setFormulaInfoList] = useState([]); // Formula field info in Metric

  // const [frequency, setFrequency] = useState("");

  const [frequency, setFrequency] = useState(FrequencyDataObj?.values[0]?.name);
  const [customFrequency, setCustomFrequency] = useState(0.01);

  const showCustomFrequencyInput = frequency === "Custom";

  const UserLogged = JSON.parse(sessionStorage.getItem("userData") || "null");
  const UserId = UserLogged?.user?.id;
  const OrgInfo = UserLogged?.user?.LastOrgId;
  const userRole = UserLogged?.user?.userRole;

  const navigate = useNavigate();

  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const {
    isOpen: isOpenLink,
    onOpen: onOpenLink,
    onOpenChange: onOpenChangeLink,
  } = useDisclosure();

  const {
    isOpen: isOpenFormula,
    onOpen: onOpenFormula,
    onOpenChange: onOpenChangeFormula,
  } = useDisclosure();

  const [tags, setTags] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [tagsValidation, setTagsValidation] = useState("");

  const [selectedAssignedTo, setSelectedAssignedTo] = useState([]);
  const [selectedApproverTo, setSelectedApproverTo] = useState([]);
  const [selectedReviewerTo, setSelectedReviewerTo] = useState([]);
  const [AllUserList, setAllUserList] = useState([]);
  const [AllApproverList, setAllApproverList] = useState([]);
  const [AllReviewerList, setAllReviewerList] = useState([]);

  // State for dynamic categories
  const [dynamicCategories, setDynamicCategories] = useState([]);
  const [isLoadingCategories, setIsLoadingCategories] = useState(false);
  const [isOpenArranger, setIsOpenArranger] = useState(false);

  const { _id, _orgId } = useParams();
  const orgFilterUrl = "filters[Organization][id][$eqi]=" + OrgInfo;

  // Fetch categories from metrics API 
  const { data: metricData } = useQuery({
    queryKey: ["metrics", orgFilterUrl],
    queryFn: () => getDataWithFilterUrl("metrics", orgFilterUrl),
  });
       
  useEffect(() => {
    // const fetchCategories = async () => {
    //   if (!OrgInfo) return;

    //   setIsLoadingCategories(true);
    //   try {
    //     const data = await getDataWithFilterUrl("metrics", orgFilterUrl);
    //     console.log("data",data)
    const metricsList = metricData?.data || [];

    // Extract unique categories from metrics data
    const uniqueCategories = [
      ...new Set(
        metricsList?.map((item) => item?.attributes?.Category)?.filter(Boolean)
      ),
    ]?.sort();

    // Convert to the format expected by the dropdown
    const categoriesList = uniqueCategories?.map((category, index) => ({
      id: (index + 1)?.toString(),
      name: category,
    }));

    setDynamicCategories(categoriesList);
  }, [metricData]);


  // const fieldListValues = Object.keys(FieldList).map((key) => {
  //   return [key, FieldList[key]];
  // });
  const fieldListValues = useMemo(() => {
    return Object?.keys(FieldList)?.map((key) => {
      return [key, FieldList[key]];
    });
  }, [FieldList]);



  const changeHandler = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };
  const handleJsonChange = (editor, data, value) => {
    setJsonData(value);
  };

  const showPreviewHandler = () => {
    setShowPreview(false);
    const validationResponse = UIMetricBuilderValidation(
      formData,
      fieldInfoList,
      requiredArr
    );

    setValidationErrors(validationResponse?.error);
    if (!validationResponse?.isValid) {
      return;
    }

    const JsonSchemaData = getJSonSchemaFromFieldInfoList(
      fieldInfoList,
      FormulaInfoList
    );

    const frameWorkResponse = {
      id: formData?.frameWork || [],
    };
    const publishData = {
      Name: formData?.metricName,
      Category: formData?.categoryName,
      ClassName: formData?.className,
      Description: formData?.description,
      Framework: frameWorkResponse,
      JsonSchema: JsonSchemaData,
      Links: getLinkJsonReponse(LinkInfoList),
      Frequency: frequency,
    };

    setPreviewData(publishData);
    setShowPreview(true);
  };
  const submitHandler = async () => {
    const validationResponse = UIMetricBuilderValidation(
      formData,
      fieldInfoList,
      requiredArr
    );

    if (!validationResponse?.isValid) {
      setValidationErrors(validationResponse.error);
      return;
    }
    const JsonSchemaData = getJSonSchemaFromFieldInfoList(
      fieldInfoList,
      FormulaInfoList
    );
    const frameWorkResponse = {
      id: formData?.frameWork || [],
    };
    const AssignedToData = selectedAssignedTo?.map((id) => +id);
    const ApproverToData =
      formData?.ApprovalWorkFlow === "1-Step Approval" ||
      formData?.ApprovalWorkFlow === "2-Step Approval"
        ? selectedReviewerTo?.map((id) => +id)
        : [];
    const ReviewerToData =
      formData?.ApprovalWorkFlow === "2-Step Approval"
        ? selectedApproverTo?.map((id) => +id)
        : [];
    const publishData = {
      Name: formData?.metricName,
      Category: formData?.categoryName,
      ClassName: formData?.className,
      Description: formData?.description,
      Framework: frameWorkResponse,
      WorkFlow: formData?.ApprovalWorkFlow,
      JsonSchema: JsonSchemaData,
      Links: getLinkJsonReponse(LinkInfoList),
      Frequency: frequency,
      FrequencyValue:
        frequency === "Custom" ? +customFrequency : FrequecyCountMap[frequency],
      TagList: tags,
      AssignedTo: AssignedToData,
      ApproverTo: ApproverToData,
      ReviewerTo: ReviewerToData,
    };

    let result = await UpdateOneData("metrics", _id, publishData);

    clientQuery.invalidateQueries({ queryKey: ["metrics", filteredUrl] });
    clientQuery.invalidateQueries({ queryKey: ["metrics", orgFilterUrl] });
    

    const newTags = tags?.filter((name) => !allTags?.includes(name));
    const updatedTags = [...allTags, ...newTags];
    await UpdateSingleCollectionData("tag", { List: updatedTags });
    clientQuery.invalidateQueries({ queryKey: ["tag"] });

    navigate(`/${_orgId}/metrics-builder`);
    window.location.reload();
  };

  const addFieldHandler = (listItem) => {
    // Ensure new fields get proper displayOrder
    const newField = {
      ...listItem,
      displayOrder: fieldInfoList?.length
    };
    setFieldInfoList([...fieldInfoList, newField]);
  };
  const addLinkHandler = (listItem) => {
    setLinkInfoList([...LinkInfoList, listItem]);
  };
  const addFormulaHandler = (listItem) => {
    setFormulaInfoList([...FormulaInfoList, listItem]);
  };

   const { data: allUser } = useQuery({
      queryKey: ["alluser"],
      queryFn: () => getAllUserOfOrgnization(),
    });
  
    const { data: allReviewer } = useQuery({
      queryKey: ["allReviewer"],
      queryFn: () => getAllReviewerOfOrgnization(),
    });
  
      const { data: allApprover } = useQuery({
        queryKey: ["allApprover"],
        queryFn: () => getAllApproverOfOrgnization(),
      });
  
 const { data: tagData } = useQuery({
    queryKey: ["tag"],
    queryFn: () => getSingleCollectionData("tag"),
  });

  const { data: frameWorkDataList } = useQuery({
     queryKey: ["frameworks"],
     queryFn: () => getDataWithFilterUrl("frameworks"),
   });
  

  
  useEffect(() => {
    const filteredUrl = `${orgFilterUrl}&filters[Category][$eqi]=framework`;
    let frameWorkData = frameWorkDataList?.data;
    const f = {};
    frameWorkData = frameWorkData?.map((item) => {
      f[item?.id] = item?.attributes?.Name;
      return { id: item?.id, name: item?.attributes?.Name };
    });
    setFrameWorkDetails(f);
    setFrameWorkList(frameWorkData);
   
  }, [frameWorkDataList]);

 const filteredUrl = `filters[id][$eqi]=${_id}`;
  const { data: singleMetricData } = useQuery({
    queryKey: ["metrics", filteredUrl],
    queryFn: () => getDataWithFilterUrl("metrics", filteredUrl)
  });

  useEffect(() => {
    let response = singleMetricData?.data[0];

    setFormData({
      metricName: response?.attributes?.Name || "",
      categoryName: response?.attributes?.Category || "",
      className: response?.attributes?.ClassName || "",
      description: response?.attributes?.Description || "",
      frameWork: response?.attributes?.Framework?.id || [],
      ApprovalWorkFlow: response?.attributes?.WorkFlow,
      SectorText: response?.attributes?.Sector || "",
    });
    const AssignedToData = response?.attributes?.AssignedTo?.data?.map((user) =>
      user?.id?.toString()
    );
    const ApproverToData = response?.attributes?.ApproverTo?.data?.map((user) =>
      user?.id?.toString()
    );
    const ReviewerToData = response?.attributes?.ReviewerTo?.data?.map((user) =>
      user?.id?.toString()
    );
    setSelectedAssignedTo(AssignedToData);
    setSelectedApproverTo(ApproverToData);
    setSelectedReviewerTo(ReviewerToData);

    const frequencyNumber = +response?.attributes?.FrequencyValue;
    const frequencyval =
      frequencyNumber === -1
        ? "Custom"
        : frequencyNumber === 30
        ? "Every month"
        : frequencyNumber === 7
        ? "Every week"
        : frequencyNumber === 1
        ? "Everyday"
        : "Only Once";

    setFrequency(frequencyval);

    setFieldInfoList(
      getFieldInfoListFromGetJSonSchema(response?.attributes?.JsonSchema) );
    setLinkInfoList(
      getLinkInfoListFromJson(response?.attributes?.Links?.Links)
    );

    setFormulaInfoList(response?.attributes?.JsonSchema?.formula || []);
    setTags(response?.attributes?.TagList || []);
    let formulaList = response?.attributes?.JsonSchema?.formula || [];
    formulaList = formulaList?.map((data) => data?.id?.toString());
    setSelectedFormulaList(formulaList);
    setOverviewList(response?.attributes?.Overview || {});
    setGuidanceList(response?.attributes?.Guidance || {});
    setMetricNameList(response?.attributes?.NameList || {});
  }, [singleMetricData]);

  useEffect(() => {
    setAllTags(tagData?.data?.attributes?.List);
  }, [tagData]);



  useEffect(() => {
    let responseAllUser = allUser;
    let responseAllReviewer = allReviewer;
    let responseAllApprover = allApprover;

    responseAllUser = responseAllUser?.map((user) => {
      return { id: user.id, name: user.username };
    });
    responseAllReviewer = responseAllReviewer?.map((user) => {
      return { id: user.id, name: user.username };
    });
    responseAllApprover = responseAllApprover?.map((user) => {
      return { id: user.id, name: user.username };
    });

    setAllUserList(responseAllUser);
    setAllApproverList(responseAllApprover);
    setAllReviewerList(responseAllReviewer);
  }, [allUser, allReviewer, allApprover]);

  const handleSaveArrangement = (arrangementData) => {
    // Update fieldInfoList with the new arrangement
    const updatedFieldInfoList = arrangementData?.fields
      ?.map((field) => ({
        ...fieldInfoList?.find((f) => f?.id === field?.id),
        visualOrder: field?.visualOrder,
        size: field?.size,
      }))
      ?.sort((a, b) => a?.visualOrder - b?.visualOrder);
    
    setFieldInfoList(updatedFieldInfoList);
    
    // Update form data with layout preferences
    setFormData((prev) => ({
      ...prev,
      preferredLayout: arrangementData?.preferredLayout,
      containerWidth: arrangementData?.containerWidth,
      fieldSizes: arrangementData?.fieldSizes,
    }));
    
    // Save to database if needed
    console.log("Field arrangement updated:", arrangementData);
    console.log("Updated field list:", updatedFieldInfoList);
    
    // You can also save this to your backend here if needed
    // For example, update the form schema in the database
  };

  return (
    <div className="flex items-start justify-between my-2">
      <div className="flex flex-col items-center w-[50%]">
        {/* Metric Name Input  */}
        <Input
          type="text"
          className="my-4"
          variant="faded"
          isRequired
          label="Metric Name"
          labelPlacement="outside"
          placeholder=" "
          name="metricName"
          value={formData?.metricName || ""}
          onChange={changeHandler}
          isInvalid={validationErrors["metricName"]}
          errorMessage={
            validationErrors["metricName"] && validationErrors["metricName"]
          }
        />

        {/* Category DropDown */}

        <div className="flex flex-col gap-2 text-sm w-full">
          <p>
            Category <span style={{ color: "red" }}>*</span>
          </p>
          {validationErrors["categoryName"] && (
            <p className="text-[#f76497]">{validationErrors["categoryName"]}</p>
          )}
          <Dropdown>
            <DropdownTrigger
              isInvalid={validationErrors["categoryName"]}
              errorMessage={
                validationErrors["categoryName"] &&
                validationErrors["categoryName"]
              }
              className="w-full"
            >
              <Button className="mb-8" variant="faded" isLoading={isLoadingCategories}>
                <div className="w-full flex justify-between">
                  <div className="flex justify-start w-full items-start">
                    {isLoadingCategories ? "Loading categories..." : (formData?.categoryName === "" ? "" : formData?.categoryName)}
                  </div>
                  <div className="flex justify-end w-full items-end">
                    <FaChevronDown />
                  </div>
                </div>
              </Button>
            </DropdownTrigger>
            <DropdownMenu
              aria-label="Static Actions"
              className="w-144"
              selectionMode="single"
              name="categoryName"
              style={{ zIndex: 9999 }}
              onSelectionChange={(event) => {
                setFormData({
                  ...formData,
                  categoryName: Array.from(event)
                    .join(", ")
                    .replaceAll("_", " "),
                });
              }}
            >
              {dynamicCategories?.length > 0 && !isLoadingCategories ? (
                dynamicCategories?.map((item) => (
                  <DropdownItem key={item.id} value={item.name}>
                    {item.name}
                  </DropdownItem>
                ))
              ) : (
                <DropdownItem key="loading" disabled>
                  Loading categories...
                </DropdownItem>
              )}
            </DropdownMenu>
          </Dropdown>
        </div>

        {/* ClassName Input */}
        <Input
          type="text"
          className="my-4"
          variant="faded"
          label="Class Name"
          value={formData?.className || ""}
          placeholder=" "
          labelPlacement="outside"
          name="className"
          onChange={changeHandler}
        />

        {/* Description Input  */}
        <Textarea
          label="Description"
          labelPlacement="outside"
          variant="faded"
          value={formData?.description || ""}
          className="my-4"
          name="description"
          onChange={changeHandler}
        />

        <Textarea
          className="my-4"
          variant="faded"
          label={`General Overview`}
          labelPlacement="outside"
          placeholder=" "
          value={overviewList?.Generic || ""}
          onChange={(event) =>
            setOverviewList({
              ...overviewList,
              Generic: event.target.value,
            })
          }
        />
        <Textarea
          className="my-4"
          variant="faded"
          label={`General Guidance`}
          labelPlacement="outside"
          placeholder=" "
          value={guidanceList?.Generic || ""}
          onChange={(event) =>
            setGuidanceList({
              ...guidanceList,
              Generic: event.target.value,
            })
          }
        />
        {DefaultOrgDetail?.id === OrgInfo && (
          <DropDownInput
            data={{
              ...sectorSchema,
              values: allSectorName,
            }}
            value={formData?.SectorText || ""}
            validationErrors={validationErrors}
            onChangeHandler={(title, value, type) =>
              setFormData({ ...formData, SectorText: value })
            }
            buttonCSS="mb-4"
          />
        )}
        {/* FrameWork Input */}

        <Select
          label="Select Framework"
          placeholder="Select any Framework"
          variant="faded"
          selectionMode="multiple"
          labelPlacement="outside"
          className="my-8"
          selectedKeys={
            new Set(
              (Array.isArray(formData?.frameWork)
                ? formData?.frameWork
                : []
              ).filter((id) =>
                frameWorkList?.some(
                  (item) => item.id.toString() === id.toString()
                )
              ) || []
            )
          }
          onSelectionChange={(event) => {
            setFormData({
              ...formData,
              frameWork: Array.from(event),
            });
          }}
        >
          {frameWorkList?.map((item) => (
            <SelectItem key={item.id} value={item.name} className="py-2">
              {item.name}
            </SelectItem>
          ))}
        </Select>

        {formData?.frameWork &&
          formData?.frameWork?.map((id, index) => {
            return (
              <FrameworFieldAccodian
                key={`framework-${id}-${index}`}
                title={frameWorkDetails[+id]}
                setMetricNameList={setMetricNameList}
                MetricNameList={MetricNameList}
                setGuidanceList={setGuidanceList}
                guidanceList={guidanceList}
                setOverviewList={setOverviewList}
                overviewList={overviewList}
              />
            );
          })}

        {/* AssignedTo User DropDown */}
        <MultiSelectInput
          data={AssignedToUserSchemaObj}
          value={selectedAssignedTo}
          valuesList={AllUserList}
          onChangeHandler={(title, value, type) => setSelectedAssignedTo(value)}
        />

        {/* Approval Workfflow DropDown */}

        <DropDownInput
          buttonCSS={"mb-8"}
          data={ApprovalWorkFlowDataSchemaObj}
          value={formData?.ApprovalWorkFlow || ""}
          validationErrors={validationErrors}
          onChangeHandler={(title, value, type) =>
            setFormData({
              ...formData,
              ApprovalWorkFlow: value,
            })
          }
        />

        {/* Approver User DropDown */}
        {(formData?.ApprovalWorkFlow === "1-Step Approval" ||
          formData?.ApprovalWorkFlow === "2-Step Approval") && (
          <MultiSelectInput
            data={ApproverUserSchemaObj}
            value={selectedApproverTo}
            valuesList={AllApproverList}
            onChangeHandler={(title, value, type) =>
              setSelectedApproverTo(value)
            }
          />
        )}

        {/* Reviewer User DropDown */}
        {formData?.ApprovalWorkFlow === "2-Step Approval" && (
          <MultiSelectInput
            data={ReviewerUserSchemaObj}
            value={selectedReviewerTo}
            valuesList={AllReviewerList}
            onChangeHandler={(title, value, type) =>
              setSelectedReviewerTo(value)
            }
          />
        )}

        <DropDownInput
          buttonCSS={"mb-8"}
          data={FrequencyDataObj}
          value={frequency}
          validationErrors={1}
          onChangeHandler={(title, value, type) => setFrequency(value)}
        />

        {showCustomFrequencyInput && (
          <CustomFrequencyInput
            value={customFrequency}
            onChangeHandler={(value) => setCustomFrequency(value)}
          />
        )}

        <MetricTagInput
          tags={tags}
          setTags={setTags}
          IntialvalidationError={tagsValidation}
          allTags={allTags}
        />

        {/* Formula Input */}

        <Select
          label="Select Formules"
          placeholder="Choose any Formules"
          variant="faded"
          selectionMode="multiple"
          labelPlacement="outside"
          className="my-8"
          selectedKeys={new Set(selectedFormulaList)}
          onSelectionChange={(event) => {
            setSelectedFormulaList(Array.from(event));
          }}
        >
          {allModels?.map((item) => (
            <SelectItem key={item.id} value={item.id} className="py-2">
              {item.title}
            </SelectItem>
          ))}
        </Select>

        {/* JsonSchema Input */}

        <div className="w-full min-h-96">
          <div className="flex items-center gap-4">
            <p className="text-lg font-medium">Build your Metric Schema</p>
          </div>
          {validationErrors["BuildData"] && (
            <p className="text-[#f76497]">{validationErrors["BuildData"]}</p>
          )}
          <p className="my-4 text-sm">
            Choose a data type and begin building your metric forms.
          </p>

          <div className="flex justify-end my-4 mr-4 gap-2">
            <Button
              size="sm"
              variant="bordered"
              onPress={() => setIsOpenArranger(true)}
              className="border-emerald-300 hover:border-emerald-400 text-emerald-700 hover:text-emerald-800 px-6 font-medium"
              startContent={<FontAwesomeIcon icon={faArrowsAltH} className="text-sm" />}
            >
              Preview & Arrange
            </Button>
            {/* <GroupedDataPreview fieldInfoList={fieldInfoList} />
            <QuickPreviewModal fieldInfoList={fieldInfoList} formData={formData} /> */}
            <Dropdown>
              <DropdownTrigger>
                <Button color="primary" size="sm">
                  Add a new field
                </Button>
              </DropdownTrigger>
              <DropdownMenu
                aria-label="Static Actions"
                selectionMode="single"
                style={{ zIndex: 9999 }}
                onSelectionChange={(event) => {
                  const selectedKey = Array.from(event)[0];
                  // Ensure we have a valid field type
                  if (selectedKey && FieldList[selectedKey]) {
                    setFieldType(selectedKey);
                    onOpen();
                  } else {
                    console.error("Invalid field type selected:", selectedKey);
                  }
                }}
              >
                {fieldListValues.map(
                  (row) =>
                    row[1].name !== "linkUrl" && (
                      <DropdownItem key={row[0]} name={row[0]}>
                        {row[1].title}
                      </DropdownItem>
                    )
                )}
              </DropdownMenu>
            </Dropdown>
          </div>

          {isOpen && (
            <AddModal
              onSubmitHandler={addFieldHandler}
              // id={deleteMetricId}
              modalHeading={"Are you sure you want to delete this Entry?"}
              isOpen={isOpen}
              onOpen={onOpen}
              onOpenChange={onOpenChange}
              fieldType={fieldType}
              id={generateUniqueId('field')}
              frameWorkDetails={frameWorkDetails}
              frameWorkList={frameWorkList}
              existingFields={fieldInfoList}
            />
          )}

          <FieldInfoTable
            fieldInfoList={fieldInfoList}
            setFieldInfoList={setFieldInfoList}
            frameWorkDetails={frameWorkDetails}
            frameWorkList={frameWorkList}
            category={formData.categoryName}
          />
        </div>

        {/* Links Input */}
        {/*
        <div className="w-full min-h-96">
          <div className="flex items-center gap-4">
            <p className="text-lg font-medium">Attach your reference links</p>
          </div>
          {validationErrors["BuildData"] && (
            <p className="text-[#f76497]">{validationErrors["BuildData"]}</p>
          )}
          <p className="my-4 text-sm">
            Attach reference links for users to fill your metrics easier
          </p>

          <div className="flex justify-end my-4 mr-4">
            <StandardAddButton size="sm" onClick={() => onOpenLink()} aria-label="Add a new link">
              Add a new link
            </StandardAddButton>
          </div>

          {isOpenLink && (
            <AddModal
              onSubmitHandler={addLinkHandler}
              // id={deleteMetricId}
              modalHeading={"Are you sure you want to delete this Entry?"}
              isOpen={isOpenLink}
              onOpen={onOpenLink}
              onOpenChange={onOpenChangeLink}
              fieldType="link"
              id={generateUniqueId('link')}
            />
          )}

          <FieldInfoTable
            fieldInfoList={LinkInfoList}
            setFieldInfoList={setLinkInfoList}
            headersList={["Name", "Link", ""]}
          />
        </div>
        */}

        {/* Formula Input */}

        <div className="w-full min-h-96">
          <div className="flex items-center gap-4">
            <p className="text-lg font-medium">Design your Formula</p>
          </div>
          {validationErrors["BuildData"] && (
            <p className="text-[#f76497]">{validationErrors["BuildData"]}</p>
          )}
          <p className="my-4 text-sm">
            Design your formula to handle mathematical calculations like
            emissions, diversity and many more.
          </p>

          <div className="flex justify-end my-4 mr-4">
            <StandardAddButton size="sm" onClick={() => onOpenFormula()} aria-label="Add a new formula">
              Add a new formula
            </StandardAddButton>
          </div>

          {isOpenFormula && (
            <AddModal
              onSubmitHandler={addFormulaHandler}
              // id={deleteMetricId}
              modalHeading={"Are you sure you want to delete this Entry?"}
              isOpen={isOpenFormula}
              onOpen={onOpenFormula}
              onOpenChange={onOpenChangeFormula}
              fieldType="formula"
              id={generateUniqueId('formula')}
            />
          )}

          <FormulaInfoTable
            fieldInfoList={FormulaInfoList}
            setFieldInfoList={setFormulaInfoList}
          />
        </div>

        {/* Preview,Submit button */}
        <div className="flex gap-4 my-4 w-full">
          <Button
            color="danger"
            variant="light"
            size="sm"
            onClick={showPreviewHandler}
            aria-label="Preview form"
          >
            Preview
          </Button>
          <StandardSubmitButton
            size="sm"
            onClick={submitHandler}
            className={`cursor-pointer ${
              userRole !== "Admin" ? "pointer-events-none opacity-50" : ""
            }`}
            aria-label="Submit form"
          >
            Submit
          </StandardSubmitButton>
        </div>
      </div>

      {/* Preview Card Open */}
      {showPreview && (
        <div className="flex flex-col items-center w-[48%]">
          <EnhancedPreviewForm data={previewData} fieldInfoList={fieldInfoList} />
        </div>
      )}

      {/* Form Field Arranger Modal */}
      <FormFieldArranger
        fieldInfoList={fieldInfoList}
        onSaveArrangement={handleSaveArrangement}
        isOpen={isOpenArranger}
        onOpenChange={setIsOpenArranger}
        preferredLayout={formData.preferredLayout}
        formData={formData}
      />
    </div>
  );
};

export default EditUIFormBuilder;